import React, { useEffect } from 'react';
import Tab from '../../../Components/Tab/Tab';
import './Info.scss';
import { alertRef } from '../../../App';
import OrderInfo from './OrderInfo/OrderInfo';
import StoreInfo from './StoreInfo/StoreInfo';
import OpertaionInfo from './OperationInfo/OperationInfo';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';

const routeList = {
    '/order/store/order-info': '주문정보',
    '/order/store/store-info' : '기본정보',
    '/order/store/operation-info' : '운영정보',
}

const Info = (props) => {
    const [ name, setName ] = React.useState('store-info')

    const route = useSelector((state) => state.user.route)
    const navigate = useNavigate();
    
    const tabRoute = [
        { route : 'store-info', header : '기본정보' },
        { route : 'operation-info', header : '운영정보' }
    ]

    return (
        <div className='wrapper'>
            <div className='header-row'>
                <p className='header-text'>오더 {'>'} 매장정보 {'>'}</p>
                <p className='header'>{routeList[route]}</p>
            </div>
            <Tab 
                routes={tabRoute}
                current={route.replace('/order/store/','')}
                onTabChange={(name) => {setName(name);navigate(`/order/store/${name}`)}}
                renderItems={{
                    'store-info' : <Outlet />,
                    'operation-info' : <Outlet />,
                }}
            />
        </div>
    )
}

export default Info;